import { Route, Routes } from 'react-router-dom';
import {
  ReservationDetailPage,
  ReservationFormPage,
  ReservationsListPage,
} from '@/modules/reservations/pages';
import { reservationsPaths } from '@/modules/reservations/paths';
import { RequirePermission } from '@/shared/components/RequirePermission';

export function ReservationsModule() {
  return (
    <Routes>
      <Route index element={<ReservationsListPage />} />
      <Route
        path={reservationsPaths.new}
        element={
          <RequirePermission permission="reservations.write">
            <ReservationFormPage />
          </RequirePermission>
        }
      />
      <Route
        path={`:id/${reservationsPaths.edit}`}
        element={
          <RequirePermission permission="reservations.write">
            <ReservationFormPage />
          </RequirePermission>
        }
      />
      <Route path={reservationsPaths.detail} element={<ReservationDetailPage />} />
    </Routes>
  );
}
